import React from "react";
import { Link } from "react-router-dom";
import { getPublicEmail } from "../lib/email/config";

const FooterMicroDisclaimer = (props) => {
  const { className = "", ...rest } = props;
  const year = new Date().getFullYear();
  const contact = getPublicEmail();
  const lastUpdated =
    process.env.REACT_APP_LEGAL_LAST_UPDATED || "September 28, 2025";

  return (
    <div
      className={`text-center text-xs text-gray-500 mt-4 ${className}`}
      data-testid="footer-micro-disclaimer"
      {...rest}
    >
      <p>
        © {year} BuildBright. Information is provided "AS IS" without
        warranties.
        <span className="mx-1">|</span>
        <Link
          to="/legal/privacy"
          className="underline hover:no-underline hover:text-gray-700 transition-colors"
        >
          Privacy Policy
        </Link>
        <span className="mx-1">|</span>
        <Link
          to="/legal/terms"
          className="underline hover:no-underline hover:text-gray-700 transition-colors"
        >
          Terms
        </Link>
        <span className="mx-1">|</span>
        <Link
          to="/legal/disclaimer"
          className="underline hover:no-underline hover:text-gray-700 transition-colors"
        >
          Disclaimer
        </Link>
        <span className="mx-1">|</span>
        <a
          href={`mailto:${contact}`}
          className="underline hover:no-underline hover:text-gray-700 transition-colors"
        >
          Contact
        </a>
      </p>
      <p className="text-xs text-gray-400 mt-1">
        Legal documents last updated: {lastUpdated}
      </p>
    </div>
  );
};

export default FooterMicroDisclaimer;
